// apiBase.ts — API 基址唯一真相源
//
// Web（开发/生产）：单域名同域部署，回落 '/api' 相对路径，零 CORS（行为与历史逐字节一致）。
// App 壳（Capacitor，见仓库根 mobile/）：构建时注入 VITE_API_BASE_URL=https://www.fai-studio.com/api
// （mobile/scripts/build-web.sh），产物落 dist-app，与 Web 的 dist 物理隔离——Web 构建不设该变量。
//
// 新代码请一律 import 本常量，不要再写死 '/api'。

export const API_BASE: string = import.meta.env.VITE_API_BASE_URL || '/api'

/** 是否运行在 Capacitor 壳内（壳内注入 window.Capacitor） */
export const IS_APP: boolean =
  typeof window !== 'undefined' && !!(window as { Capacitor?: unknown }).Capacitor
